import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable, NgZone} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

/**
 * Re-enters the Angular zone after each HTTP response or error.
 * Some runtimes (or mixed fetch/XHR paths) can complete without scheduling change detection, leaving
 * spinners and bound state stuck until the next user interaction. This keeps marketing (and the rest
 * of the admin shell) in sync with completed requests.
 */
@Injectable()
export class NgZoneHttpEnsureCdInterceptor implements HttpInterceptor {
  constructor(private readonly zone: NgZone) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const bump = (): void => {
      this.zone.run(() => {
        /* empty run schedules a turn so the app can stabilize and run CD if needed */
      });
    };
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          bump();
        }
      }),
      catchError((err: unknown) => {
        bump();
        return throwError(() => err);
      }),
    );
  }
}
